import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { KycDocumentsPage } from './SmartUpload/KycDocumentsPage';
import './SmartUploadTab.scss';

/**
 * Smart Upload (OCR) tab in the Investor Dashboard.
 * Hosts the KycDocumentsPage component tree described in
 * KYC_DOCUMENT_PLAN.md §3.8.
 *
 * Journey context (family redesign): /investor/documents-center?journeyId=X scopes the
 * requirement view + uploads to that journey's PERSON. No param = the login investor's
 * own person — the standalone document manager, exactly as before.
 */
export const SmartUploadTab: React.FC = () => {
  const [searchParams] = useSearchParams();
  const journeyId = searchParams.get('journeyId');
  const freshMode = searchParams.get('fresh') === '1';
  // mode=upload: journey-less page still shows the uploader (login person's
  // requirements) — used by flows that need documents completed outside a journey,
  // e.g. the delegation KYC gate. Default journey-less = document manager only.
  const uploadMode = searchParams.get('mode') === 'upload';
  return (
    <div className="smart-upload-tab">
      <KycDocumentsPage journeyId={journeyId} freshMode={freshMode} uploadMode={uploadMode} />
    </div>
  );
};

export default SmartUploadTab;
